let config = require('../../package.json');

export const environment = {
  production: false,
  version: config.version,
  product: config.name,
  title: config.title,
  homepage: config.homepage,
  description: config.description,
  homecomponent: config.homecomponent,
  firebase: {
    apiKey: 'AIzaSyCh1apaVaaOR2w-hclYibEOY2Fa-lVubcE',
    authDomain: 'saru-tech.firebaseapp.com',
    databaseURL: 'https://saru-tech.firebaseio.com',
    projectId: 'saru-tech',
    storageBucket: 'saru-tech.appspot.com',
    messagingSenderId: '118779350897',
    appId: '1:118779350897:web:d9e24bc9da4ae3d772b0d0',
    measurementId: 'G-K777JVR3L5',
  },
  zoom: {
    sdkKey: 'lAY0i05qkXFBrUe2j2pYgMFGHW1E5LdsyH7A',
  },
  signKey: 'R8TZxWIBAaAV90bmroOpUUBSFgnZ1Q9c1J7d0Uhk',
  stripe: {
    production: true,
    stripeTestKey: 'pk_test_UGjs8wsGFq9nRgXHSHV1zsmz',
    stripeKey: 'pk_live_r4YrMdde7YVDNKOnXS4b42f7',
  },
  couchdb: {
    username: 'appadmin',
    password: '100%Apps',
  },
  paystack: {
    production: 'pk_live_0bad4f005b449630c5e7a582551f4edfdbc493a2',
    test: 'pk_test_f86fd4ef27fe495ac82b0174d852699f49f323ae',
  },
  paypal: {
    sandbox: 'AQLJkIT6ytAX3Vwz-AQqGb_Yin2wa8ClwnQ5gHv1Svd0APYj1VNxghT9M7ZfHuFYrfRTE17r_XyaSx7z',
    production: 'AWmkmBfF3q_Eu5aqZyZ5cX3FW0F8y3SbkMdlN1xMSILyO6q4BWaj8peKkCFur3BTuKFapI0oWpwkljnS',
  },
  analytics: config.analytics,
};
